import mandi from "../../../assets/images/trade.svg";
import UserAvatar from "../../../components/avatar";
import MemoizedGaugeChartNewUI from "../gauge-meter";
const MarketMandiRmDetailsCard: React.FC<{
  name: string;
  subText: string;
  riskScore: number;
  profileImg: string;
  fromMarketCard?: boolean;
  className?: string;
  id?: any;
}> = ({
  name,
  subText,
  riskScore,
  profileImg,
  fromMarketCard,
  className,
  id,
}) => {
    return (
      <div
        className={`flex w-full border br-10 min-h-[114px] card_space_18 ${className}`}
      >
        <div className="flex gap-2 justify-between items-center w-100">
          <div className="flex gap-2 items-center">
            {fromMarketCard ? (
              <img src={mandi} />
            ) : (
              <>
                {profileImg ? (
                  <img
                    src={profileImg}
                    alt="user_profile_pic"
                    className="w-8 h-8 br-100"
                    style={{ maxWidth: "initial" }}
                  />
                ) : (
                  <UserAvatar name={name} />
                )}
              </>
            )}
            <div className="flex flex-col">
              <span className="text-sm ">{name}</span>
              <div className="text-xs color-sub-text ">
                {id && (
                  <span className="">
                    {fromMarketCard ? "MARKET" : "ONO"} ID:{" "}
                    <span className="color-blue">{id}</span>
                  </span>
                )}
                {id && !fromMarketCard ? (
                  <span>
                    {" | "}
                    {subText}
                  </span>
                ) : (
                  <div>{subText}</div>
                )}
              </div>
            </div>
          </div>
          <div className="flex items-end">
            <div className="flex-1 px-2 flex flex-col items-center justify-center">
              <MemoizedGaugeChartNewUI
                id={`gauge-chart-${id}`}
                percent={riskScore ? riskScore / 10 : 0}
              />
              <span
                className={`font-semibold text-sm text-center 
                  ${riskScore <= 3
                    ? "color-red"
                    : riskScore <= 5 && riskScore > 2
                      ? "color-red"
                      : riskScore <= 7 && riskScore > 5
                        ? 'color-orange '
                        : riskScore <= 9 && riskScore > 7
                          ? 'color-primary' :
                          riskScore === 10 ?
                            'color-primary' : ''}
                                    `}
              >
                {riskScore} / 10{" "}
                {riskScore <= 3
                  ? "Very High"
                  : riskScore <= 5 && riskScore > 2
                    ? "High"
                    : riskScore <= 7 && riskScore > 5
                      ? 'Moderate'
                      : riskScore <= 9 && riskScore > 7
                        ? 'Low' :
                        riskScore === 10 ?
                          'Very Good' : ''}
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  };
export default MarketMandiRmDetailsCard;
